import {
	GLI_Container,
	GLI_CountLesson,
	GLI_Name,
	GLI_ProgressBar,
	GLI_ProgressFill,
	groupLessonItemVariants,
} from "./GroupLessonItem.styled";
import { GrandChartGroupLessonStore } from "../../../../../../../../../stores/grand-charts/grand-chart-group-lesson.store";
import { ServiceName } from "../../../../../../../../../constants";
import { calculatePercent } from "../../../../../../../../../helpers";
import { observer } from "mobx-react";
import { useStores } from "../../../../../../../../../stores";
import { useEffect, useRef, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import {
	getGrandChartRoute,
	getGroupLessonRoute,
} from "../../../../../../../../../helpers/grandChart/grandChart.helper";
import { useIsOverflow } from "../../../../../../../../../hooks";
import { Tooltip } from "../../../../../../../Tooltip";

interface GroupLessonItemProps {
	service: ServiceName;
	groupLessonItemStore: GrandChartGroupLessonStore;
}

export const GroupLessonItem = observer(({ service, groupLessonItemStore }: GroupLessonItemProps) => {
	const { grandCharts, statisticsStore } = useStores();
	const { selected } = grandCharts;

	const navigate = useNavigate();
	const location = useLocation();
	const [showStatistics, setShowStatistics] = useState(false);

	const currentPassedSecond = statisticsStore.getByGroupLessonId(groupLessonItemStore.id);
	const currentPassedProgress = calculatePercent(groupLessonItemStore.totalAllLessonsTime, currentPassedSecond);

	const countLesson = groupLessonItemStore.lessons.length;

	useEffect(() => {
		const timer = window.setTimeout(() => {
			setShowStatistics(true);
		}, 450);
		return () => window.clearTimeout(timer);
	}, []);

	const handleOnShowGroupLesson = () => {
		navigate(
			getGroupLessonRoute(location.pathname, {
				grandChartId: selected.id,
				courseId: groupLessonItemStore.grand_chart_course_id,
				moduleId: groupLessonItemStore.grand_chart_module_id,
				groupId: groupLessonItemStore.id,
			}),
		);
	};

	return (
		<GLI_Container $service={service} variants={groupLessonItemVariants} onClick={handleOnShowGroupLesson}>
			<Tooltip content={groupLessonItemStore.name}>
				<GLI_Name>{groupLessonItemStore.name}</GLI_Name>
			</Tooltip>

			<AnimatePresence>
				{showStatistics && (
					<>
						<GLI_ProgressBar
							key="progress"
							initial={{ opacity: 0, y: 4 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0, y: 4 }}
							transition={{
								duration: 0.22,
								ease: [0.16, 1, 0.3, 1],
							}}
						>
							<GLI_ProgressFill
								initial={{ width: 0 }}
								animate={{ width: `${currentPassedProgress}%` }}
								transition={{
									delay: 0.12,
									duration: 0.7,
									ease: [0.16, 1, 0.3, 1],
								}}
							/>
						</GLI_ProgressBar>

						<GLI_CountLesson
							key="count-lesson"
							initial={{ opacity: 0, scale: 0.75, y: 4 }}
							animate={{ opacity: 1, scale: 1, y: 0 }}
							exit={{ opacity: 0, scale: 0.75, y: 4 }}
							transition={{
								delay: 0.08,
								duration: 0.24,
								ease: [0.16, 1, 0.3, 1],
							}}
						>
							{countLesson}
						</GLI_CountLesson>
					</>
				)}
			</AnimatePresence>
		</GLI_Container>
	);
});
